import { render, staticRenderFns } from "./thietLapKySo.vue?vue&type=template&id=5305d38d&scoped=true&"
import script from "./thietLapKySo.vue?vue&type=script&lang=js&"
export * from "./thietLapKySo.vue?vue&type=script&lang=js&"
import style0 from "./thietLapKySo.vue?vue&type=style&index=0&id=5305d38d&scoped=true&lang=css&"
import style1 from "./thietLapKySo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5305d38d",
  null
  
)

export default component.exports